import { render, staticRenderFns } from "./IssueSolvingItem.vue?vue&type=template&id=6b05c5e9"
import script from "./IssueSolvingItem.vue?vue&type=script&lang=ts"
export * from "./IssueSolvingItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports